import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ModalTipping,
  ModalLike,
  ModalInsight,
} from 'global/StreamWidget/Modals';
import { FooterContainer } from 'global/StreamWidget/Post/styled';
import { effects } from 'global/StreamWidget/slice';
import ModalShare from 'global/ModalShare';
import { effects as chatEffects } from 'lib/entities/chat/slice';
import { PROJECT_FOLDER } from 'constants/app';
import { StreamPostData } from '../../../../../@types/stream';
import Web from './Web';
import Mobile from './Mobile';

interface FooterProps {
  post: StreamPostData;
  onComment: (val: any) => any;
}

function Footer({ post, onComment }: FooterProps) {
  const dispatch = useDispatch();

  const [modalShare, showModalShare] = useState(false);
  const [modalTipping, showModalTipping] = useState(false);
  const [modalLike, showModalLike] = useState(false);
  const [modalInsight, showModalInsight] = useState(false);

  const { likes, liked, postid, created_display: created } = post;

  const handleLikePost = () => {
    const action = liked ? effects.unlikePost : effects.likePost;
    dispatch(action(postid));
  };

  const handleShareToChat = async (chatData) => {
    const send = await dispatch(chatEffects.sendBulkChat({
      ...chatData,
      attachment_url: '',
      shared_content: {
        type: 'SHARED_CONTENT_TYPE_STREAM',
        id: post.postid,
      },
    }));
      // @ts-ignore
    const { error } = send.payload;

    if (!error) {
      showModalShare(false);
    }
  };

  const showInsight = post.analytics;
  const urlToShare = useMemo(() => {
    const path = !PROJECT_FOLDER || PROJECT_FOLDER === '/' ? '/' : `/${PROJECT_FOLDER}/`;
    return `${window.location.origin}${path}post/${post.postid}`;
  }, [post]);

  return (
    <FooterContainer>
      <Web
        likes={likes}
        liked={liked}
        isAuthor={post.is_author}
        showInsight={showInsight}
        onClickInsight={() => showModalInsight(true)}
        onClickLike={handleLikePost}
        onClickLikers={() => showModalLike(true)}
        onClickShare={() => showModalShare(true)}
        onClickTipping={() => showModalTipping(true)}
        onClickComment={onComment}
      />
      <Mobile
        likes={likes}
        liked={liked}
        created={created}
        showInsight={showInsight}
        onClickInsight={() => showModalInsight(true)}
        onClickLike={handleLikePost}
        onClickLikers={() => showModalLike(true)}
        onClickShare={() => showModalShare(true)}
        onClickComment={onComment}
      />
      <ModalShare
        post={post}
        sendChat={handleShareToChat}
        title="Share"
        hasCopyButton
        hasRepostButton={post.is_author === 0}
        hasSearchPeople
        hasSocialMedia
        hasShareInput
        urlToShare={urlToShare}
        visible={modalShare}
        onCancel={() => showModalShare(false)}
      />
      <ModalTipping
        streamId={postid}
        userId={post.userid}
        username={post.username}
        avatar={post.avatar}
        visible={modalTipping}
        onCancel={() => showModalTipping(false)}
      />
      <ModalLike
        likes={likes}
        streamId={postid}
        visible={modalLike}
        onCancel={() => showModalLike(false)}
      />
      <ModalInsight
        visible={modalInsight}
        post={post}
        onCancel={() => showModalInsight(false)}
      />
    </FooterContainer>
  );
}

export default Footer;
